import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId) {
  return apiFetch({ endPoint: `Margin/GetAll/${dossierSubTypeId}`, method: 'GET', body: null, token: token })
}
